import { render } from "./Accountinfo.vue?vue&type=template&id=0a7f7753&scoped=true"
import script from "./Accountinfo.vue?vue&type=script&lang=ts"
export * from "./Accountinfo.vue?vue&type=script&lang=ts"

import "./Accountinfo.vue?vue&type=style&index=0&id=0a7f7753&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a7f7753"

export default script